const d3 = require("d3");
var _ = require('lodash');

var dataviz = d3.select("#dataviz-chart-state-accel-plot");

var size = {
    width: 546,
    height: 340
}

var margin = { top: 100, right: 40, bottom: 60, left: 50 };
let width = 1080;
let height = 600;
let realWidth = width - margin.left - margin.right;

let showAccel = true;
let smoothTermSetting = 14;
let stateSetting = "AL";
let chartCredit = "test credit";
let dateSetting = "2020-02-01";
let visualDateSetting = "2020-02-14";
let dateSettingTo = new Date().toISOString().split('T')[0];

const domain = "http://localhost:3333/data/";
// prod domain is "https://apps.statnews.com/CovidDataUtility/"
// dev domain is "http://localhost:3333/data/"
// app test domain is "https://apps.statnews.com/covid-state-accel-plots/public/data/"

let getMovingAvg = function(input, smoothTerm, offset) {
    let arrayLength = input.length;
    let theArray = [];
    let termIndex = smoothTerm - 1;

    for (let step = termIndex; step < arrayLength; step++) {
        let curDate = input[step].date;
        let theAvg = 0;

        for (let i = step - termIndex; i <= step; i++) {
            theAvg = theAvg + input[i].value;
        };

        theAvg = theAvg / smoothTerm;

        let theObject = {
            date: curDate,
            value: theAvg,
            state: input[step].state,
            state_name: input[step].state_name,
            region: input[step].region,
            division: input[step].division
        };

        theArray.push(theObject);
    };

    return theArray;
}

let getAcceleration = function(input) {
    let prevVal = input[0].value;
    let theArray = [];

    _.each(input, function(element, index) {
        let theObject = {
            date: element.date,
            value: element.value - prevVal,
            state: element.state,
            state_name: element.state_name,
            region: element.region,
            division: element.division
        }

        theArray.push(theObject);

        prevVal = element.value;
    });

    return theArray;
};

let getPeakVal = function(input, from, to) {
    return d3.max(_.filter(input, function(i) {
        return i.date > new Date(from) && i.date < new Date(to);
    }), d => d.value);
};

let mapStateData = function(input, smooth, variable) {
    let mappednewdata = _.map(input, function(i, name) {
        let currentDate = new Date(i.submission_date);
        let currVal = parseInt(i[variable]);

        if (currVal === null) {
            currVal = 0;
        }

        if (smooth === true) {
            currVal = currVal / 7;
        }

        return {
            date: currentDate,
            value: currVal,
            state: i.state,
            state_name: i.state_name,
            region: i.Region,
            division: i.Division
        }
    });

    mappednewdata = _.reject(mappednewdata, function(i) {
        return i.date < new Date(dateSetting);
    });

    mappednewdata = _.reject(mappednewdata, function(i) {
        return i.date > new Date(dateSettingTo);
    });

    return mappednewdata;
}

// create top container
const topContainer = dataviz.append("div")
    .attr("class", "accel-chart-top-container");

// create svg canvas for state bar chart
const stateBars = topContainer.append("svg")
    .attr("viewBox", [0, 0, 500, 900])
    .style("color", "rgba(0,0,0,0.4)")
    .attr("class", "accel-state-bar-chart")
    .attr("font-family", "Circular");

// make the svg map container
const svgMap = topContainer.append("div")
    .attr("class", "accel-map-menu");

svgMap.append("h4")
    .text("Select a state/territory for detailed data:");

const toplineReqUrl = domain + "top-accel-by-state.json";

// load topline accel data and build map
d3.json(toplineReqUrl).then(data => {
    console.log(data)

    data = _.reject(data, { "state": "NYC" });

    let colorScale = d3.scaleSqrt().domain([d3.min(data, d => d.value), 0, d3.max(data, d => d.value)])
        .range(["#1fadb6", "#a3a3a3", "#df4c51"])

    let theStates = svgMap.selectAll("div")
        .data(data)
        .enter()
        .append("div")
        .attr("class", "state-menu-item")
        .style("background-color", d => { return colorScale(d.value) })
        .text(d => { return d.state })
        .attr("value", d => { return d.state })

    theStates.on("click", d => {
        console.log(d.target.attributes.value.value);

        stateSetting = d.target.attributes.value.value;
        updateCharts(d.target.attributes.value.value);
    })

    // paint the state bar chart

    let metric = "asbolute";

    let xbar = d3.scaleLinear()
        .domain(d3.extent(data, d => d.value))
        .rangeRound([margin.left, 500 - margin.right]);

    let ybar = d3.scaleBand()
        .domain(d3.range(data.length))
        .rangeRound([90, 900])
        .padding(0.1);

    let format = d3.format(metric === "absolute" ? "+,d" : "+.2f");

    let xAxisbar = g => g
        .attr("transform", `translate(0,${margin.top - 5})`)
        .call(d3.axisTop(xbar).ticks(width / 180).tickFormat(tickFormat))
        .call(g => g.select(".domain").remove());

    let yAxisbar = g => g
        .attr("transform", `translate(${xbar(0)},0)`)
        .call(d3.axisLeft(ybar).tickFormat(i => data[i].state_name).tickSize(0).tickPadding(6))
        .call(g => g.selectAll(".tick text").filter(i => data[i].value < 0)
            .attr("text-anchor", "start")
            .attr("x", 6));

    let tickFormat = metric === "absolute" ? d3.formatPrefix("+.1", 1e6) : format;

    stateBars.append("g")
        .selectAll("rect")
        .data(data)
        .enter().append("rect")
        .attr("fill", d => d.value > 0 ? "#df4c51" : "#1fadb6")
        .attr("x", d => xbar(Math.min(d.value, 0)))
        .attr("y", (d, i) => ybar(i))
        .attr("width", d => Math.abs(xbar(d.value) - xbar(0)))
        .attr("height", ybar.bandwidth());

    stateBars.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .attr("fill", "rgba(0,0,0,0.5)")
        .selectAll("text")
        .data(data)
        .enter().append("text")
        .attr("text-anchor", d => d.value < 0 ? "end" : "start")
        .attr("x", d => xbar(d.value) + Math.sign(d.value - 0) * 4)
        .attr("y", (d, i) => ybar(i) + ybar.bandwidth() / 2)
        .attr("dy", "0.35em")
        .attr("font-family", "Circular")
        .text(d => format(d.value));

    stateBars.append("g")
        .call(xAxisbar)
        .attr("font-family", "Circular")
        .style("color", "rgba(0,0,0,0.5)");

    stateBars.append("g")
        .call(yAxisbar)
        .attr("font-family", "Circular")
        .style("color", "rgba(0,0,0,0.8)")
        .selectAll("path")
        .attr("stroke", "rgba(0,0,0,0)");

    stateBars.append("text")
        .attr("x", 0)
        .attr("y", 50)
        .style("font-size", "22px")
        .attr("fill", "#000000")
        .attr("font-family", "Circular")
        .attr("font-weight", "bold")
        .text("Covid-19 case acceleration by state/territory");

    stateBars.append("text")
        .attr("x", 0)
        .attr("y", 70)
        .style("font-size", "14px")
        .attr("fill", "rgba(0,0,0,0.6)")
        .attr("font-family", "Circular")
        .text("Cases per 100k people / week / day");

}).catch(error => {
    console.log(error);
});

// globalize chart objects
let svg;
let svgVeloc;
let theAccelLine;
let accelYAxis;
let velYAxis;
let accelChartTitle;
let accelGradient;

// function to update charts
function updateCharts(state) {
    let url = domain + "cases-" + state + ".json";
    console.log(url);

    d3.json(url).then(data => {
        svg.remove();
        svgVeloc.remove();

        let stateAllCases = mapStateData(data, false, "new_case");
        let stateAvgCases = getMovingAvg(stateAllCases, 14, 7);

        let stateCasesAccel = getAcceleration(stateAvgCases);
        let stateCasesAccelSmooth = getMovingAvg(stateCasesAccel, 14, 7);

        // setup chart utils
        let statey = d3.scaleLinear()
            .domain([((showAccel) ? d3.min(stateCasesAccelSmooth, d => d.value) - 10 : 0), d3.max(((showAccel) ? stateCasesAccelSmooth : stateAllCases), d => d.value) + ((showAccel) ? 10 : 0)]).nice()
            .range([height - margin.bottom, margin.top]);

        let stateyVel = d3.scaleLinear()
            .domain([0, d3.max(stateAllCases, d => d.value)]).nice()
            .range([height - margin.bottom, margin.top]);

        let xAxis = g => g
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x).ticks(width / 180).tickSizeOuter(0))
            .call(g => g.selectAll(".tick line").clone()
                .attr("y2", -(height - 150))
                .attr("stroke-opacity", 0.16));

        let x = d3.scaleTime()
            .domain([new Date(visualDateSetting), new Date(dateSettingTo)])
            .range([margin.left, width - margin.right]);

        let stateyAxis = g => g
            .attr("transform", `translate(${margin.left - 5},0)`)
            .call(d3.axisLeft(statey).ticks(6).tickSize(0).tickFormat(d3.format(".2s")))
            .call(g => g.select(".domain").remove())
            .call(g => g.select(".tick:last-of-type text").clone()
                .attr("x", 3)
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text(data.y))
            .call(g => g.selectAll(".tick line").clone()
                .attr("x1", 5)
                .attr("x2", width - 150)
                .attr("stroke-opacity", 0.16));

        let stateyAxisVel = g => g
            .attr("transform", `translate(${margin.left - 5},0)`)
            .call(d3.axisLeft(stateyVel).ticks(6).tickSize(0).tickFormat(d3.format(".2s")))
            .call(g => g.select(".domain").remove())
            .call(g => g.select(".tick:last-of-type text").clone()
                .attr("x", 3)
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text(data.y))
            .call(g => g.selectAll(".tick line").clone()
                .attr("x1", 5)
                .attr("x2", width - 150)
                .attr("stroke-opacity", 0.16));

        let stateArea = d3.area()
            .curve(d3.curveStep)
            .x(d => x(d.date))
            .y0(statey(0))
            .y1(d => statey(d.value));

        let stateLine = d3.line()
            .defined(d => !isNaN(d.value))
            .x(d => x(d.date))
            .y(d => statey(d.value));

        let stateLineVel = d3.line()
            .defined(d => !isNaN(d.value))
            .x(d => x(d.date))
            .y(d => stateyVel(d.value));


        // calculate utility values
        let stateFirstWavePeakVal = getPeakVal(stateCasesAccelSmooth, "2020-03-01", "2020-06-01");
        let stateThirdWavePeakVal = getPeakVal(stateCasesAccelSmooth, "2020-10-01", "2021-02-01")

        // make the chart
        svg = dataviz.append("svg")
            .attr("viewBox", [0, 0, width, height])
            .style("background", "#ffffff")
            .attr("font-size", 14)
            .attr("font-family", "Circular")
            .style("color", "rgba(0,0,0,0.4)");

        const pctOffset = statey(0) / height;
        const annotColor = "rgba(0,0,0,0.5)";

        accelGradient = svg.append("linearGradient")
            .attr("id", "state-area-gradient")
            .attr("gradientUnits", "userSpaceOnUse")
            .attr("x1", 0).attr("y1", 0)
            .attr("x2", 0).attr("y2", height)
            .selectAll("stop")
            .data([
                { offset: "0%", color: "rgba(223,76,81,1)" },
                { offset: pctOffset, color: "rgba(223,76,81,1)" },
                { offset: pctOffset, color: "rgba(31,173,182,1)" },
                { offset: "100%", color: "rgba(31,173,182,1)" }
            ])
            .enter().append("stop")
            .attr("offset", function(d) { return d.offset; })
            .attr("stop-color", function(d) { return d.color; });

        svg.append("g")
            .call(xAxis)
            .attr("font-family", "Circular")
            .attr("font-size", 20);

        accelYAxis = svg.append("g")
            .call(stateyAxis)
            .attr("font-family", "Circular")
            .attr("font-size", 20);

        svg.append("svg:line")
            .attr("x1", margin.left)
            .attr("x2", width - margin.left)
            .attr("y1", statey(0))
            .attr("y2", statey(0))
            .attr("stroke", "rgba(0,0,0,0.7)")
            .attr("fill", "none")
            .attr("stroke-width", 1)

        svg.append("text")
            .attr("x", x(new Date("2021-01-20")))
            .attr("y", statey(stateThirdWavePeakVal) * 1.18)
            .style("font-size", "14px")
            .attr("fill", "rgba(223,76,81,1)")
            .attr("font-family", "Circular")
            .attr("font-weight", "bold")
            .text(smoothTermSetting + "-day average");

        if (stateFirstWavePeakVal) {
            svg.append("svg:line")
                .attr("x1", margin.left)
                .attr("x2", width - margin.left)
                .attr("y1", statey(stateFirstWavePeakVal) - 1)
                .attr("y2", statey(stateFirstWavePeakVal) - 1)
                .attr("stroke", annotColor)
                .attr("fill", "none")
                .attr("stroke-width", 1)

            svg.append("text")
                .attr("x", margin.left)
                .attr("y", statey(stateFirstWavePeakVal) - 6)
                .style("font-size", "14px")
                .attr("fill", annotColor)
                .attr("font-family", "Circular")
                .text("First wave peak");
        }

        svg.append("svg:line")
            .attr("x1", margin.left)
            .attr("x2", width - margin.left)
            .attr("y1", statey(stateThirdWavePeakVal) - 1)
            .attr("y2", statey(stateThirdWavePeakVal) - 1)
            .attr("stroke", annotColor)
            .attr("fill", "none")
            .attr("stroke-width", 1)

        svg.append("text")
            .attr("x", margin.left)
            .attr("y", statey(stateThirdWavePeakVal) - 6)
            .style("font-size", "14px")
            .attr("fill", annotColor)
            .attr("font-family", "Circular")
            .text("Fall/winter 2020 peak");

        svg.append("path")
            .datum(stateCasesAccel)
            .attr("fill", "url(#state-area-gradient)")
            .attr("opacity", 0.16)
            .attr("stroke", "none")
            .attr("stroke-width", 0)
            .attr("stroke-linejoin", "miter")
            .attr("stroke-linecap", "butt")
            .attr("d", stateArea);

        theAccelLine = svg.append("path")
            .datum(stateCasesAccelSmooth)
            .attr("fill", "none")
            .attr("stroke", "url(#state-area-gradient)")
            .attr("stroke-width", 3)
            .attr("stroke-linejoin", "miter")
            .attr("stroke-linecap", "butt")
            .attr("d", stateLine);

        svg.append("text")
            .attr("x", 0)
            .attr("y", 76)
            .style("font-size", "18px")
            .attr("fill", "rgba(0,0,0,0.6)")
            .attr("font-family", "Circular")
            .text("Cases / week / day");

        svg.append("text")
            .attr("x", 0)
            .attr("y", 50)
            .style("font-size", "28px")
            .attr("fill", "#000000")
            .attr("font-family", "Circular")
            .attr("font-weight", "bold")
            .text("Covid-19 case acceleration in " + stateSetting);

        // make the chart
        svgVeloc = dataviz.append("svg")
            .attr("viewBox", [0, 0, width, height])
            .style("background", "#ffffff")
            .attr("font-size", 14)
            .attr("font-family", "Circular")
            .style("color", "rgba(0,0,0,0.4)");

        svgVeloc.append("linearGradient")
            .attr("id", "state-area-gradient")
            .attr("gradientUnits", "userSpaceOnUse")
            .attr("x1", 0).attr("y1", 0)
            .attr("x2", 0).attr("y2", height)
            .selectAll("stop")
            .data([
                { offset: "0%", color: "rgba(223,76,81,1)" },
                { offset: pctOffset, color: "rgba(223,76,81,1)" },
                { offset: pctOffset, color: "rgba(31,173,182,1)" },
                { offset: "100%", color: "rgba(31,173,182,1)" }
            ])
            .enter().append("stop")
            .attr("offset", function(d) { return d.offset; })
            .attr("stop-color", function(d) { return d.color; });

        svgVeloc.append("g")
            .call(xAxis)
            .attr("font-family", "Circular")
            .attr("font-size", 20);

        svgVeloc.append("g")
            .call(stateyAxisVel)
            .attr("font-family", "Circular")
            .attr("font-size", 20);

        svgVeloc.append("path")
            .datum(stateAvgCases)
            .attr("fill", "none")
            .attr("stroke", "#1fadb6")
            .attr("stroke-width", 4)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .attr("d", stateLineVel);

        svgVeloc.append("g")
            .attr("fill", "#1fadb6")
            .attr("opacity", 0.4)
            .selectAll("rect")
            .data(stateAllCases)
            .join("rect")
            .attr("x", d => x(d.date))
            .attr("y", d => stateyVel(d.value))
            .attr("height", d => stateyVel(0) - stateyVel(d.value))
            .attr("width", ((width - 160) / data.length) / 3);

        svgVeloc.append("text")
            .attr("x", 0)
            .attr("y", 76)
            .style("font-size", "18px")
            .attr("fill", "rgba(0,0,0,0.6)")
            .attr("font-family", "Circular")
            .text("Cases / day");

        svgVeloc.append("text")
            .attr("x", 0)
            .attr("y", 50)
            .style("font-size", "28px")
            .attr("fill", "#000000")
            .attr("font-family", "Circular")
            .attr("font-weight", "bold")
            .text("New Covid-19 cases in " + stateSetting);

        // get last update data

        let stateCaseDataLastDate = _.last(stateAvgCases).date.toISOString().split('T')[0];

        svgVeloc.append("text")
            .attr("x", 0)
            .attr("y", 590)
            .style("font-size", "15px")
            .attr("fill", "rgba(0,0,0,0.6)")
            .attr("font-family", "Circular")
            .text("Data current as of: " +
                stateCaseDataLastDate);


    }).catch(error => {
        console.log(error);
    });

}

const firstStateReqUrl = domain + "cases-" + stateSetting + ".json";

// load accel data
d3.json(firstStateReqUrl).then(data => {

    let stateAllCases = mapStateData(data, false, "new_case");
    let stateAvgCases = getMovingAvg(stateAllCases, 14, 7);

    let stateCasesAccel = getAcceleration(stateAvgCases);
    let stateCasesAccelSmooth = getMovingAvg(stateCasesAccel, 14, 7);

    // setup chart utils
    let statey = d3.scaleLinear()
        .domain([((showAccel) ? d3.min(stateCasesAccelSmooth, d => d.value) - 10 : 0), d3.max(((showAccel) ? stateCasesAccelSmooth : stateAllCases), d => d.value) + ((showAccel) ? 10 : 0)]).nice()
        .range([height - margin.bottom, margin.top]);

    let stateyVel = d3.scaleLinear()
        .domain([0, d3.max(stateAllCases, d => d.value)]).nice()
        .range([height - margin.bottom, margin.top]);

    let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x).ticks(width / 180).tickSizeOuter(0))
        .call(g => g.selectAll(".tick line").clone()
            .attr("y2", -(height - 150))
            .attr("stroke-opacity", 0.16));

    let x = d3.scaleTime()
        .domain([new Date(visualDateSetting), new Date(dateSettingTo)])
        .range([margin.left, width - margin.right]);

    let stateyAxis = g => g
        .attr("transform", `translate(${margin.left - 5},0)`)
        .call(d3.axisLeft(statey).ticks(6).tickSize(0).tickFormat(d3.format(".2s")))
        .call(g => g.select(".domain").remove())
        .call(g => g.select(".tick:last-of-type text").clone()
            .attr("x", 3)
            .attr("text-anchor", "start")
            .attr("font-weight", "bold")
            .text(data.y))
        .call(g => g.selectAll(".tick line").clone()
            .attr("x1", 5)
            .attr("x2", width - 150)
            .attr("stroke-opacity", 0.16));

    let stateyAxisVel = g => g
        .attr("transform", `translate(${margin.left - 5},0)`)
        .call(d3.axisLeft(stateyVel).ticks(6).tickSize(0).tickFormat(d3.format(".2s")))
        .call(g => g.select(".domain").remove())
        .call(g => g.select(".tick:last-of-type text").clone()
            .attr("x", 3)
            .attr("text-anchor", "start")
            .attr("font-weight", "bold")
            .text(data.y))
        .call(g => g.selectAll(".tick line").clone()
            .attr("x1", 5)
            .attr("x2", width - 150)
            .attr("stroke-opacity", 0.16));

    let stateArea = d3.area()
        .curve(d3.curveStep)
        .x(d => x(d.date))
        .y0(statey(0))
        .y1(d => statey(d.value));

    let stateLine = d3.line()
        .defined(d => !isNaN(d.value))
        .x(d => x(d.date))
        .y(d => statey(d.value));

    let stateLineVel = d3.line()
        .defined(d => !isNaN(d.value))
        .x(d => x(d.date))
        .y(d => stateyVel(d.value));

    // calculate utility values
    let stateFirstWavePeakVal = getPeakVal(stateCasesAccelSmooth, "2020-03-01", "2020-06-01");
    let stateThirdWavePeakVal = getPeakVal(stateCasesAccelSmooth, "2020-10-01", "2021-02-01")

    // make the chart
    svg = dataviz.append("svg")
        .attr("viewBox", [0, 0, width, height])
        .style("background", "#ffffff")
        .attr("font-size", 14)
        .attr("font-family", "Circular")
        .style("color", "rgba(0,0,0,0.4)");

    const pctOffset = statey(0) / height;
    const annotColor = "rgba(0,0,0,0.5)";

    accelGradient = svg.append("linearGradient")
        .attr("id", "state-area-gradient")
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", 0).attr("y1", 0)
        .attr("x2", 0).attr("y2", height)
        .selectAll("stop")
        .data([
            { offset: "0%", color: "rgba(223,76,81,1)" },
            { offset: pctOffset, color: "rgba(223,76,81,1)" },
            { offset: pctOffset, color: "rgba(31,173,182,1)" },
            { offset: "100%", color: "rgba(31,173,182,1)" }
        ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; });

    svg.append("g")
        .call(xAxis)
        .attr("font-family", "Circular")
        .attr("font-size", 20);

    accelYAxis = svg.append("g")
        .call(stateyAxis)
        .attr("font-family", "Circular")
        .attr("font-size", 20);

    svg.append("svg:line")
        .attr("x1", margin.left)
        .attr("x2", width - margin.left)
        .attr("y1", statey(0))
        .attr("y2", statey(0))
        .attr("stroke", "rgba(0,0,0,0.7)")
        .attr("fill", "none")
        .attr("stroke-width", 1)

    svg.append("text")
        .attr("x", x(new Date("2021-01-20")))
        .attr("y", statey(stateThirdWavePeakVal) * 1.18)
        .style("font-size", "14px")
        .attr("fill", "rgba(223,76,81,1)")
        .attr("font-family", "Circular")
        .attr("font-weight", "bold")
        .text(smoothTermSetting + "-day average");

    if (stateFirstWavePeakVal) {
        svg.append("svg:line")
            .attr("x1", margin.left)
            .attr("x2", width - margin.left)
            .attr("y1", statey(stateFirstWavePeakVal) - 1)
            .attr("y2", statey(stateFirstWavePeakVal) - 1)
            .attr("stroke", annotColor)
            .attr("fill", "none")
            .attr("stroke-width", 1)

        svg.append("text")
            .attr("x", margin.left)
            .attr("y", statey(stateFirstWavePeakVal) - 6)
            .style("font-size", "14px")
            .attr("fill", annotColor)
            .attr("font-family", "Circular")
            .text("First wave peak");
    }

    svg.append("svg:line")
        .attr("x1", margin.left)
        .attr("x2", width - margin.left)
        .attr("y1", statey(stateThirdWavePeakVal) - 1)
        .attr("y2", statey(stateThirdWavePeakVal) - 1)
        .attr("stroke", annotColor)
        .attr("fill", "none")
        .attr("stroke-width", 1)

    svg.append("text")
        .attr("x", margin.left)
        .attr("y", statey(stateThirdWavePeakVal) - 6)
        .style("font-size", "14px")
        .attr("fill", annotColor)
        .attr("font-family", "Circular")
        .text("Fall/winter 2020 peak");

    svg.append("path")
        .datum(stateCasesAccel)
        .attr("fill", "url(#state-area-gradient)")
        .attr("opacity", 0.16)
        .attr("stroke", "none")
        .attr("stroke-width", 0)
        .attr("stroke-linejoin", "miter")
        .attr("stroke-linecap", "butt")
        .attr("d", stateArea);

    theAccelLine = svg.append("path")
        .datum(stateCasesAccelSmooth)
        .attr("fill", "none")
        .attr("stroke", "url(#state-area-gradient)")
        .attr("stroke-width", 3)
        .attr("stroke-linejoin", "miter")
        .attr("stroke-linecap", "butt")
        .attr("d", stateLine);

    svg.append("text")
        .attr("x", 0)
        .attr("y", 76)
        .style("font-size", "18px")
        .attr("fill", "rgba(0,0,0,0.6)")
        .attr("font-family", "Circular")
        .text("Cases / week / day");

    svg.append("text")
        .attr("x", 0)
        .attr("y", 50)
        .style("font-size", "28px")
        .attr("fill", "#000000")
        .attr("font-family", "Circular")
        .attr("font-weight", "bold")
        .text("Covid-19 case acceleration in " + stateSetting);

    // make the chart
    svgVeloc = dataviz.append("svg")
        .attr("viewBox", [0, 0, width, height])
        .style("background", "#ffffff")
        .attr("font-size", 14)
        .attr("font-family", "Circular")
        .style("color", "rgba(0,0,0,0.4)");

    svgVeloc.append("linearGradient")
        .attr("id", "state-area-gradient")
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", 0).attr("y1", 0)
        .attr("x2", 0).attr("y2", height)
        .selectAll("stop")
        .data([
            { offset: "0%", color: "rgba(223,76,81,1)" },
            { offset: pctOffset, color: "rgba(223,76,81,1)" },
            { offset: pctOffset, color: "rgba(31,173,182,1)" },
            { offset: "100%", color: "rgba(31,173,182,1)" }
        ])
        .enter().append("stop")
        .attr("offset", function(d) { return d.offset; })
        .attr("stop-color", function(d) { return d.color; });

    svgVeloc.append("g")
        .call(xAxis)
        .attr("font-family", "Circular")
        .attr("font-size", 20);

    svgVeloc.append("g")
        .call(stateyAxisVel)
        .attr("font-family", "Circular")
        .attr("font-size", 20);

    svgVeloc.append("path")
        .datum(stateAvgCases)
        .attr("fill", "none")
        .attr("stroke", "#1fadb6")
        .attr("stroke-width", 4)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .attr("d", stateLineVel);

    svgVeloc.append("g")
        .attr("fill", "#1fadb6")
        .attr("opacity", 0.4)
        .selectAll("rect")
        .data(stateAllCases)
        .join("rect")
        .attr("x", d => x(d.date))
        .attr("y", d => stateyVel(d.value))
        .attr("height", d => stateyVel(0) - stateyVel(d.value))
        .attr("width", ((width - 160) / data.length) / 3);

    svgVeloc.append("text")
        .attr("x", 0)
        .attr("y", 76)
        .style("font-size", "18px")
        .attr("fill", "rgba(0,0,0,0.6)")
        .attr("font-family", "Circular")
        .text("Cases / day");

    svgVeloc.append("text")
        .attr("x", 0)
        .attr("y", 50)
        .style("font-size", "28px")
        .attr("fill", "#000000")
        .attr("font-family", "Circular")
        .attr("font-weight", "bold")
        .text("New Covid-19 cases in " + stateSetting);

    // get last update data

    let stateCaseDataLastDate = _.last(stateAvgCases).date.toISOString().split('T')[0];

    svgVeloc.append("text")
        .attr("x", 0)
        .attr("y", 590)
        .style("font-size", "15px")
        .attr("fill", "rgba(0,0,0,0.6)")
        .attr("font-family", "Circular")
        .text("Data current as of: " +
            stateCaseDataLastDate);

}).catch(error => {
    console.log(error);
});